module.exports = __webpack_public_path__ + "static/img/products_pool_mobile.251aaa7b.jpg";